// extracted by mini-css-extract-plugin
export default {"scrollBar":"club-form-page_scrollBar__N26IB","textAreaScroll":"club-form-page_textAreaScroll__+FYOd","scrollable":"club-form-page_scrollable__ZWJ91 club-form-page_scrollBar__N26IB"};